module.exports = __webpack_public_path__ + "assets/img/logAudit-module6-3.5930801e.jpg";